var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container text-center"},[_c('h1',[_vm._v("404")]),_c('hr'),_c('br'),_vm._v(" The page you are looking for is lost in the fields. "),_c('div',{staticClass:"center"},[_c('vs-button',{attrs:{"size":"large"},on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("Go back home")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }